import type { Severity } from "@/shared/ui/severity-dot";

// Цвет доли побед: от 52% — хорошо, от 45% — можно лучше, ниже — плохо.
export const winRateSeverity = (winRate: number): Severity =>
  winRate >= 0.52 ? "good" : winRate >= 0.45 ? "warn" : "bad";
